import { render, staticRenderFns } from "./ViewpointCreator.vue?vue&type=template&id=6d4627b2&scoped=true&"
import script from "./ViewpointCreator.vue?vue&type=script&lang=ts&"
export * from "./ViewpointCreator.vue?vue&type=script&lang=ts&"
import style0 from "./ViewpointCreator.vue?vue&type=style&index=0&id=6d4627b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4627b2",
  null
  
)

export default component.exports